import React, { useState } from 'react';

import { productApi as api } from 'api/product';
import { FormComponent, Notifications } from 'shared';

function CreateCohort() {
    const [notification, setNotification] = useState({ text: null, level: null });

    const formFields = [
        { name: 'name', inputElement: 'textField', label: 'Name', gridValue: 12, inputProps: { required: true } },
        {
            name: 'description',
            inputElement: 'textField',
            label: 'Description',
            gridValue: 12,
            inputProps: { multiline: true, rows: 3 },
        },
    ];

    return (
        <div>
            <h1>Create cohort</h1>
            <Notifications options={notification} />
            {}
            <div style={{ outline: 0, backgroundColor: 'white' }}>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData, resetForm) => {
                        const sendParams = {
                            name: formData.name,
                        };
                        if (formData.description !== undefined && formData.description !== '') {
                            sendParams.description = formData.description;
                        }

                        const response = await api.createCohort(sendParams);
                        if (response.status === true) {
                            setNotification({ text: 'Cohort created', level: 'success' });
                            resetForm();
                        } else {
                            setNotification({
                                text: response?.msg ? `Error: ${response.msg}` : 'Error creating cohort',
                                level: 'error',
                            });
                        }
                    }}
                />
            </div>
        </div>
    );
}

export { CreateCohort };
